import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
import { useDispatch } from 'react-redux'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
const MailSent = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const closeDrawer = () => {
    dispatch(messageBoxHideAction())
  }
  return (
    <>
      <div className={classes.mailSent__header__icon}>
        <img
          src={'/assets/done_img.png'}
          alt={'mail-sent'}
          width={100}
          height={100}
        />
        <Typography textAlign={'center'} fontSize="18px" fontWeight={500}>
          Your delivery has been done!
        </Typography>
        <Typography
          textAlign={'center'}
          fontSize="14px"
          fontWeight={400}
          color="#838D98"
        >
          We intend to employ your collection name along with a concise,
          <br />
          uninterrupted link tailored specifically for the group or individual
          <br />
          learner within the groups you've chosen.
        </Typography>
        <CoreButton
          size="small"
          variant="outlined"
          onClick={() => closeDrawer()}
          color="secondary"
        >
          Close
        </CoreButton>
      </div>
    </>
  )
}

export default withStyles(styles)(MailSent)
